import {Group, NativeSelect, SegmentedControl, Text} from '@mantine/core'
import {format} from 'date-fns'

import {parseApiDate} from 'src/jobs/job-schedule-format'

import type {BookingScope} from './use-booking-scope'

type BookingScopeControlProps = {
    jobId: string
    scope: BookingScope
    onScopeChange: (scope: BookingScope) => void
    day: string
    days: string[]
    onDayChange: (day: string) => void
}

export function BookingScopeControl({
    jobId,
    scope,
    onScopeChange,
    day,
    days,
    onDayChange,
}: BookingScopeControlProps) {
    return (
        <Group gap="sm" data-testid="booking-scope">
            <Text size="sm" fw={500} id={`booking-scope-label-${jobId}`}>
                Book drivers for
            </Text>
            <SegmentedControl
                size="xs"
                aria-labelledby={`booking-scope-label-${jobId}`}
                value={scope}
                onChange={(value) => onScopeChange(value as BookingScope)}
                data={[
                    {value: 'every_day', label: 'Every day'},
                    {value: 'one_day', label: `Just ${format(parseApiDate(day), 'EEE MMM d')}`},
                ]}
            />
            {scope === 'one_day' && days.length > 1 ? (
                <NativeSelect
                    size="xs"
                    aria-label="Day to book"
                    value={day}
                    onChange={(event) => onDayChange(event.currentTarget.value)}
                    data={days.map((option) => ({
                        value: option,
                        label: format(parseApiDate(option), 'EEE MMM d'),
                    }))}
                />
            ) : null}
        </Group>
    )
}
